// import http from './Http';

// const obtenerPerfil = () => {
//   return http.get('/auth/me');
// };

// const PerfilService = {
//   obtenerPerfil,
// };

// export default PerfilService;

import http from "./Http";

const obtenerRoles = async () => {
  const response = await http.get("/roles/");
  return response.data;
};

const RoleService = {
  obtenerRoles,
};

export default RoleService;